const 
// feHost = 'https://www.iraq-gis.com/';
// feHost="http://192.168.80.34:3000/"
 feHost=window.location.origin+'/ticket-system/'
// feHost="http://dev.ticket.is/"
// feHost="http://www.ticket.is/"
 export default feHost;
